// extracted by mini-css-extract-plugin
module.exports = {"BookingTextArea":"BookingTextField_BookingTextArea__NPZaR","TagContainer":"BookingTextField_TagContainer__2RFeW","TagButton":"BookingTextField_TagButton__1XBKj"};